import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { Text, Button } from 'src/Components'
import history from 'src/history'
import { OVERLAY_HELPERS } from 'src/constants/navigation'
import ListingActionBar from 'src/Components/ListingDetails/ListingActionBar'
import NmlsInfo from '../NmlsInfo'
import StatusHeader from '../StatusHeader'
import PropertyStats from '../PropertyStats'
import LocationMap from '../LocationMap'
import AddressSection from '../AddressSection'
import Description from '../Description'
import ThingsToNote from '../ThingsToNote'
import HomeDetails from '../HomeDetails'
import AgentCard from '../AgentCard'
import StickyBranding from '../StickyBranding'
import SimilarHomes from '../SimilarHomes'
import { MobileChromeExtensionPromptCard } from '../ChromeExtensionPromptCard/Mobile/MobileChromeExtensionPromptCard'
import styles from './MobileListingDetails.module.scss'
import ListingsBot from '../ListingsBot'

const propTypes = {
  listing: PropTypes.shape({
    imageCoverUrl: PropTypes.string,
    thumbnailImageFileNames: PropTypes.arrayOf(PropTypes.string),
  }),
  similarListings: PropTypes.arrayOf(PropTypes.object),
}

const MobileListingDetails = ({ listing, similarListings }) => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    })
  }, [])

  const handleOnClick = () => {
    history.push(OVERLAY_HELPERS.listingDetailsPhotos.buildPath())
  }

  return (
    <div>
      <div className={styles.actionBarContainer}>
        <ListingActionBar listing={listing} />
      </div>
      <div className={styles.imageContainer}>
        {/* link should open slideshow modal */}
        <Button onClick={handleOnClick}>
          <img
            alt='property'
            src={listing.imageCoverUrl}
            className={styles.heroImage}
          />
          <Text
            element='span'
            size='xs'
            variant='neutralCool'
            variantCount={900}
            className={styles.imageCounter}
          >
            {`1 / ${listing.thumbnailImageFileNames?.length}`}
          </Text>
        </Button>
      </div>
      <div className={styles.body}>
        <NmlsInfo listing={listing} />
        <div className={styles.statsContainer}>
          <StatusHeader className={styles.statusHeader} listing={listing} />
          <PropertyStats listing={listing} />
        </div>
        <div className={styles.section}>
          <LocationMap listing={listing} showHeading={false} />
          <AddressSection listing={listing} className={styles.address} />
        </div>
        <div className={styles.section}>
          <ListingsBot listing={listing} />
        </div>

        <Description listing={listing} className={styles.section} />
        <ThingsToNote listing={listing} className={styles.section} />
        <HomeDetails listing={listing} className={styles.section} />
        <AgentCard className={styles.section} />

        {similarListings.length > 0 && (
          <SimilarHomes
            listings={similarListings}
            className={styles.section}
            isSlim={false}
          />
        )}

        <MobileChromeExtensionPromptCard className={styles.section} />
      </div>
      <StickyBranding />
    </div>
  )
}

MobileListingDetails.propTypes = propTypes

export default MobileListingDetails
